import { Box, Button, Flex, Link, Text, VStack } from "@chakra-ui/react";
import { Modal } from "antd";
import React from "react";
import { FaChrome } from "react-icons/fa6";
import { MdCalendarToday } from "react-icons/md";
import { BuyerAPI } from "../../Apis/buyerAPI";
import { relevanceFields } from "../../Constants/data";

// Claude: extracted from SellersList.tsx 23-03-2026
interface Props {
  item: any;
  accordionActive: string;
  setAccordionActive: (v: string) => void;
  sellerEvents: Record<string, any[]>;
  setSellerEvents: React.Dispatch<React.SetStateAction<Record<string, any[]>>>;
  meetingData: any;
  buyerData: any;
  user: any;
  setRelevanceData: (v: any) => void;
  handleOpenRelevanceModal: () => void;
  setNotesData: React.Dispatch<React.SetStateAction<any>>;
  handleOpenNotesModal: () => void;
  setPersonName: (v: string) => void;
  getAssets: (sellerId: string) => void;
  setTagsData: (v: string[]) => void;
  handleOpenTagsModal: () => void;
  setMeetResponder: (v: any) => void;
  handleOpenMeetModal: () => void;
  handleOpenMeetConfirmModal: () => void;
  setCurrentMeet: (v: string) => void;
  isNewMeetingAllowed: (status: string) => boolean;
  error: (msg: string) => void;
}

const SellerCard = ({
  item, accordionActive, setAccordionActive, sellerEvents, setSellerEvents,
  meetingData, buyerData, user,
  setRelevanceData, handleOpenRelevanceModal,
  setNotesData, handleOpenNotesModal,
  setPersonName, getAssets,
  setTagsData, handleOpenTagsModal,
  setMeetResponder, handleOpenMeetModal, handleOpenMeetConfirmModal, setCurrentMeet,
  isNewMeetingAllowed, error,
}: Props) => (
  <Box
    p={"15px"}
    _hover={{ shadow: "md", bg: "#D7F5D3" }}
    border={"1px solid #E2E8F0"}
    borderRadius={"15px"}
    shadow={"sm"}
    bg={accordionActive == item?.sellers?.sellerId ? "white" : "transparent"}
    onClick={() => {
      if (accordionActive == item?.sellers?.sellerId) {
        setAccordionActive("");
      } else {
        setAccordionActive(item?.sellers?.sellerId);
        // Claude: Fetch tradeshow events for this seller if not already cached 24-02-2026
        if (!sellerEvents[item?.sellers?.sellerId]) {
          BuyerAPI.getSellerEvents(item?.sellers?.sellerId)
            .then((res: any) => {
              setSellerEvents((prev) => ({
                ...prev,
                [item?.sellers?.sellerId]: res?.data?.data || [],
              }));
            })
            .catch(() => {});
        }
      }
    }}
  >
    <Flex justifyContent={"space-between"} alignItems={"center"}>
      <Text fontWeight={"medium"} fontSize={"sm"}>{item.companyName}</Text>
      <Box
        height={18}
        width={18}
        borderRadius={"2px"}
        background={relevanceFields.find((s) => s.status === item.prequalificationStatus)?.color}
        onClick={(e: any) => {
          e.stopPropagation();
          handleOpenRelevanceModal();
          setRelevanceData({
            prequalified_company_name: item.companyName,
            prequalified_user_id: item.sellers.sellerId,
            event_id: item.eventId,
            status: item.prequalificationStatus,
          });
        }}
      />
    </Flex>

    <Box
      mt={3}
      overflow={accordionActive == item.sellers.sellerId ? "visible" : "hidden"}
      opacity={accordionActive == item.sellers.sellerId ? 1 : 0}
      height={accordionActive == item.sellers.sellerId ? "auto" : "0px"}
      transition={"all 0.5s ease-in-out"}
    >
      <VStack>
        <Box width={"100%"}>
          <Flex gap={2}>
            <Text fontSize={"sm"} fontWeight={"medium"} mb={"2px"}>{item?.sellers?.personName}</Text>
          </Flex>
          <Flex gap={2} mb={"6px"}>
            <Text fontSize={"small"} fontWeight={"light"}>{item?.sellers?.personDesignation}</Text>
          </Flex>
          <Flex gap={2} mb={"2px"}>
            <Text fontSize={"small"} fontWeight={"medium"}>Address:</Text>
            <Text fontSize={"small"} fontWeight={"light"}>
              {item?.sellers?.companyHqCity ? item?.sellers?.companyHqCity + "," : ""}
              {item?.sellers?.companyHqState ? item?.sellers?.companyHqState + ", " : ""}
              {item?.sellers?.companyHqCountry ? item?.sellers?.companyHqCountry : ""}
            </Text>
          </Flex>
          {item?.sellers?.companyTimezone && (
            <Flex gap={2} mb={"2px"}>
              <Text fontSize={"small"} fontWeight={"medium"}>Timezone</Text>
              <Text fontSize={"small"} fontWeight={"light"}>{item?.sellers?.companyTimezone}</Text>
            </Flex>
          )}
          {/* Claude: Company Info 01-03-2026 */}
          {item?.sellers?.companyInfo && (
            <Flex gap={2} mb={"2px"}>
              <Text fontSize={"small"} fontWeight={"light"} color="gray.600">{item?.sellers?.companyInfo}</Text>
            </Flex>
          )}
          {/* Claude: Company Type badges 14-04-2026 */}
          {item?.sellers?.sellerCompanyType?.length > 0 && (
            <Flex gap={1} mb={"4px"} flexWrap={"wrap"} alignItems={"center"}>
              <Text fontSize={"small"} fontWeight={"medium"} whiteSpace={"nowrap"}>Type:</Text>
              {item.sellers.sellerCompanyType.map((t: string, i: number) => (
                <span key={i} style={{ padding: "2px 7px", backgroundColor: "#E3F2FD", color: "#1565C0", borderRadius: "3px", fontSize: "10px" }}>
                  {t === "Others" && item.sellers.sellerCompanyTypeOther ? item.sellers.sellerCompanyTypeOther : t}
                </span>
              ))}
            </Flex>
          )}
          {/* Claude: Tradeshows — shown above tags 24-02-2026 */}
          {sellerEvents[item?.sellers?.sellerId]?.length > 0 && (
            <Flex gap={2} mb={"2px"} flexWrap={"wrap"} alignItems={"flex-start"}>
              <Text fontSize={"small"} fontWeight={"medium"} whiteSpace={"nowrap"}>Tradeshows:</Text>
              <Flex flexWrap={"wrap"} gap={1}>
                {sellerEvents[item?.sellers?.sellerId].map((ev: any, i: number) => (
                  <span key={i} style={{ padding: "2px 7px", backgroundColor: "#EEF2FF", color: "#3730A3", borderRadius: "3px", fontSize: "10px" }}>
                    {ev.eventName}
                  </span>
                ))}
              </Flex>
            </Flex>
          )}
          <Flex gap={2} mb={"2px"}>
            <Text whiteSpace={"nowrap"} fontSize={"small"} fontWeight={"medium"}>Tags:</Text>
            <Text display={"flex"} flexWrap={"wrap"} alignItems={"center"} gap={2}>
              {item?.sellers?.productTypeTags?.filter((v: any, i: number) => i < 2)?.map((tag: any, i: number) => (
                <span key={i} style={{ padding: "2px 7px", color: "#000000", backgroundColor: "#FFD2CD", borderRadius: "3px", fontSize: "10px" }} className="whitespace-nowrap">
                  {tag}
                </span>
              ))}
              {item?.sellers?.productTypeTags?.length > 2 ? (
                <button
                  className="text-[#2869FE] text-start"
                  style={{ fontSize: "10px" }}
                  onClick={() => { setTagsData(item?.sellers?.productTypeTags); handleOpenTagsModal(); }}
                >
                  ...more
                </button>
              ) : null}
            </Text>
          </Flex>
          <Flex gap={2} mb={"2px"}>
            <Text fontSize={"small"} fontWeight={"medium"}>Notes : </Text>
            <Link
              color={"card.borderBlue"}
              onClick={() => {
                setNotesData((prev: any) => ({
                  forUser: item?.sellers?.sellerId,
                  eventId: item?.eventId,
                }));
                handleOpenNotesModal();
              }}
            >
              <Text color={"card.borderBlue"} fontSize={"xs"}>&nbsp;View/Add</Text>
            </Link>
          </Flex>
          <Flex gap={2} mb={"2px"}>
            <Text fontSize={"small"} fontWeight={"medium"}>Digital Assets : </Text>
            <Link
              color={"card.borderBlue"}
              onClick={() => { setPersonName(item.companyName); getAssets(item.sellers.sellerId); }}
            >
              <Text color={"card.borderBlue"} fontSize={"xs"}>&nbsp;Documents, Images & Videos</Text>
            </Link>
          </Flex>
          {/* Claude: seller verification status — Verified (green) or Pending (gray) 03-03-2026 */}
          <Flex gap={2} mb={"2px"} alignItems={"center"}>
            <Text fontSize={"small"} fontWeight={"medium"}>Verification:</Text>
            <Text fontSize={"small"} fontWeight={"medium"} color={item?.sellers?.verificationStatus === "verified" ? "green.500" : "gray.400"}>
              {item?.sellers?.verificationStatus === "verified" ? "Verified" : "Pending"}
            </Text>
          </Flex>
        </Box>
        <Flex width={"100%"} justifyContent={"space-around"}>
          {item?.sellers?.companyUrl && (
            <VStack gap={0}>
              <Button colorScheme="transparent" onClick={() => window.open(item?.sellers?.companyUrl, "_blank")}>
                <span><FaChrome size={22} color={"#F5793D"} /></span>
              </Button>
              <Text fontWeight={"regular"} fontSize={"xs"}>Site</Text>
            </VStack>
          )}
          <VStack gap={0}>
            <Button
              colorScheme="transparent"
              onClick={() => {
                // Claude: gate for inactive plan — show warning before opening modal 11-04-2026
                if (buyerData?.isPlanActive === false) {
                  Modal.warning({ title: "Alert!", content: "Subscription limits reached. Please renew to continue." });
                  return;
                }
                if (!buyerData.buyerPhoneNumber)
                  return error("Please provide your contact number in the profile page");
                if (meetingData[item?.sellers.companyName]) {
                  const meetingObj = meetingData[item?.sellers.companyName];
                  if (isNewMeetingAllowed(user.user === meetingObj.requesterId ? meetingObj.requesterStatus : meetingObj.responderStatus)) {
                    setMeetResponder(item);
                    handleOpenMeetModal();
                  } else {
                    handleOpenMeetConfirmModal();
                    setCurrentMeet(meetingObj._id);
                  }
                } else {
                  setMeetResponder(item);
                  handleOpenMeetModal();
                }
              }}
            >
              <MdCalendarToday color={"#F5793D"} size={22} />
            </Button>
            <Text fontWeight={"regular"} fontSize={"xs"}>Meet</Text>
          </VStack>
        </Flex>
      </VStack>
    </Box>
  </Box>
);

export default SellerCard;
